import React from "react";
import {
  List,
  Datagrid,
  Edit,
  Create,
  SimpleForm,
  TextField,
  DateField,
  EditButton,
  TextInput,
  
  ReferenceInput,
  SelectInput,
  DateTimeInput,
  translate,
  FunctionField,
  Show,
  SimpleShowLayout,

  ListButton,
  Filter
} from "react-admin";
import { CardActions } from "@material-ui/core";
import {
    required,
    password,
    passwordEdit,
    passwordEquals
} from "../../validators/validators";


export const SubscriberList = props => (
  <List {...props} exporter={false} bulkActionButtons={false}>
    <Datagrid>
      <TextField label="resources.misc.fields.id" source="id" />
      <TextField label="resources.misc.fields.title" source="title" />
      <EditButton label="" /> 
    </Datagrid>
  </List>
);

const ClientCustomerTitle = ({ record }) => {
    return (
      <span>{record ? record.title : ""}</span>
    );
};

const cardActionStyle = {
    zIndex: 2,
    display: "inline-block",
    float: "right"
};

const Actions = ({ basePath, data, refresh }) => (
  <CardActions style={cardActionStyle}>
    <EditButton basePath={basePath} record={data} />
    <ListButton basePath={basePath} />
  </CardActions>
);

export const SubscriberShow = props => (
  <Show 
  title={<ClientCustomerTitle />} 
  actions={<Actions />}
  {...props}>
    <SimpleShowLayout>
      <DateField label="resources.misc.fields.id" source="id" />
      <DateField label="resources.misc.fields.title" source="title" />
    </SimpleShowLayout>
  </Show>
);

export const SubscriberEdit = ({ permissions, ...props }) => (
  <Edit title={<ClientCustomerTitle />} actions={<CardActions />} {...props}>
    <SimpleForm>
     
      <TextInput
        label="resources.misc.fields.title"
        source="title"
        validate={[required()]}
      />
    </SimpleForm>
  </Edit>
);

export const SubscriberCreate = ({ permissions, ...props }) => (
  <Create title="Nov naročnik" {...props}>
    <SimpleForm redirect="list">
      <TextInput
        label="resources.misc.fields.title"
        source="title"
        validate={[required()]}
      />

    </SimpleForm>
  </Create>
);